// src/components/Auth/AuthPage.jsx

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiMail,
  FiLock,
  FiEye,
  FiEyeOff,
  FiUser,
} from "react-icons/fi";
import "./Authpage.css";
import { LoginService } from "../../services/ApiService";

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [loginData, setLoginData] = useState({
     username: "",
    password: "",
  });

  const [registerData, setRegisterData] = useState({
    firstName: "",
    lastName: "",
    username: "",
     password: "",
  });
const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#()_+\-=])[A-Za-z\d@$!%*?&#()_+\-=]{8,10}$/;
  // LOGIN
 const handleLogin = async (e) => {

  e.preventDefault();

  setLoading(true);
if (!PASSWORD_REGEX.test(loginData.password)) {
  alert(
    "Invalid password format."
  );
  return;
}
  const payload = {
    // email: loginData.email,
    email: `${loginData.username}@tapasyatech.in`,
    password: loginData.password,
  };

  try {

    const response = await LoginService.login(payload);

    console.log("Login Success:", response);

    if (response.status === true) {

      // Store user data in localStorage
      localStorage.setItem(
        "user_id",
        response.user_id
      );

      localStorage.setItem(
        "username",
        response.username
      );

      localStorage.setItem(
        "email",
        response.email
      );

      // Optional full user object
      localStorage.setItem(
        "user",
        JSON.stringify(response)
      );

      // Redirect directly
      window.location.href = "/dashboard";
    }

  } catch (error) {

    console.log("Login Failed:", error);

    alert(
      error.message || "Invalid Email or Password"
    );

  } finally {

    setLoading(false);
  }
};


  // REGISTER
 const handleRegister = async (e) => {

  e.preventDefault();

  // PASSWORD VALIDATION
if (!PASSWORD_REGEX.test(registerData.password)) {
  alert(
    "Password must be 8-10 characters long and contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character."
  );
  return;
}

  setLoading(true);

  const payload = {
    username:
      registerData.firstName +
      " " +
      registerData.lastName,

    // email: registerData.email,
    email: `${registerData.username}@tapasyatech.in`,

    password: registerData.password,
  };

  try {

    const response =
      await LoginService.register(
        payload
      );

    console.log(response);
    setRegisterData({
  firstName: "",
  lastName: "",
  username: "",
  password: "",
});
setShowPassword(false);

    alert("User Registered Successfully");

    setIsLogin(true);

  } catch (error) {

    console.log(error);

    alert(
      error.message ||
      "Registration Failed"
    );

  } finally {

    setLoading(false);
  }
};


const switchToRegister = () => {
  setLoginData({
    username: "",
    password: "",
  });

  setIsLogin(false);
};

const switchToLogin = () => {
  setRegisterData({
    firstName: "",
    lastName: "",
    username: "",
    password: "",
  });

  setIsLogin(true);
};


  return (
    <div className="auth-wrapper">
      <div className="bg-orb orb1"></div>
      <div className="bg-orb orb2"></div>
      <div className="grid-overlay"></div>

      <motion.div
        className="auth-container"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* LEFT SIDE */}
        <div className="left-panel">
          <div className="brand-content">
           
<div className="brand-logo-wrapper">
  <img
    src="/TT_logo2.png"
    alt="ReqSphere Logo"
    className="brand-logo"
  />
  <br></br>
</div>


            <span className="tag">
              REQUIREMENTS MANAGEMENT
            </span>

            <h1>ReqSphere</h1>

            <p>
              Smart documentation platform for
              requirement tracking, compliance,
              verification, and enterprise
              requirement lifecycle management.
            </p>

            <div className="cyber-line"></div>

            <span className="sub-text">
              Structured • Secure • Scalable
            </span>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="right-panel">
          <AnimatePresence mode="wait">
            {isLogin ? (
              <motion.form
                key="login"
                className="auth-form"
                onSubmit={handleLogin}
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -40 }}
                transition={{ duration: 0.3 }}
              >
                <h2>Welcome Back</h2>

                <p className="subtitle">
                  Login to continue to ReqSphere
                </p>

                {/* EMAIL */}
{/* EMAIL */}
<div className="fixed-email-wrapper">
  <FiMail className="icon" />

  <input
    type="text"
    placeholder="Enter username"
    value={loginData.username}
    onChange={(e) => {
      const value = e.target.value;
      // Allow alphabets, numbers, and periods
      if (/^[a-zA-Z0-9.]*$/.test(value)) {
        setLoginData({
          ...loginData,
          username: value,
        });
      }
    }}
    required
  />

  <span className="fixed-domain">
    @tapasyatech.in
  </span>
</div>
                {/* <div className="input-group">
                  <FiMail className="icon" />
                  <input
                    type="email"
                    placeholder="Email Address"
                    value={loginData.email}
                    onChange={(e) =>
                      setLoginData({
                        ...loginData,
                        email: e.target.value,
                      })
                    }
                    required
                  />
                </div> */}

                {/* PASSWORD */}
                <div className="input-group">
                  <FiLock className="icon" />

<input
  className="password-input"
  type={showPassword ? "text" : "password"}
  placeholder="Password"
  value={loginData.password}
  onChange={(e) =>
    setLoginData({
      ...loginData,
      password: e.target.value,
    })
  }
  required
/>

                  <span
                    className="eye-icon"
                    onClick={() =>
                      setShowPassword(
                        !showPassword
                      )
                    }
                  >
                    {showPassword ? (
                      <FiEyeOff />
                    ) : (
                      <FiEye />
                    )}
                  </span>
                </div>
{/* 
                <div className="options">
                  <label>
                    <input type="checkbox" />
                    Remember me
                  </label>

                  <span className="forgot-password">
                    Forgot Password?
                  </span>
                </div> */}

                <button
                  type="submit"
                  className="auth-btn"
                   disabled={loading}
>
                
                  {loading
                    ? "Signing In..."
                    : "Login"}
                </button>

                <p className="switch-text">
                  New user?
                  <span
                    // onClick={() =>
                    //   setIsLogin(false)
                    // }
                    onClick={switchToRegister}
                  >
                    Register
                  </span>
                </p>
              </motion.form>
            ) : (
              <motion.form
                key="register"
                className="auth-form"
                onSubmit={handleRegister}
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -40 }}
                transition={{ duration: 0.3 }}
              >
                <h2>Create Account</h2>

                <p className="subtitle">
                  Register for requirements
                  access
                </p>

                <div className="name-row">
                  <div className="input-group">
                   

<input
  type="text"
  placeholder="First Name"
  value={registerData.firstName}
  onChange={(e) => {
    const value = e.target.value;

    if (/^[A-Za-z]*$/.test(value)) {
      setRegisterData({
        ...registerData,
        firstName: value,
      });
    }
  }}
  maxLength={30}
  required
/>
                  </div>

                  <div className="input-group">
                   

<input
  type="text"
  placeholder="Last Name"
  value={registerData.lastName}
  onChange={(e) => {
    const value = e.target.value;

    if (/^[A-Za-z]*$/.test(value)) {
      setRegisterData({
        ...registerData,
        lastName: value,
      });
    }
  }}
  maxLength={30}
  required
/>
                  </div>
                </div>

                <div className="fixed-email-wrapper">
  <FiMail className="icon" />

  <input
    type="text"
    placeholder="Enter username"
    value={registerData.username}
  onChange={(e) => {
  const value = e.target.value;

  // Allow only alphabets, numbers, and periods
  if (/^[a-zA-Z0-9.]*$/.test(value)) {
    setRegisterData({
      ...registerData,
      username: value,
    });
  }
}}
    required
  />

  <span className="fixed-domain">
    @tapasyatech.in
  </span>
</div>

                {/* <div className="input-group">
                  <FiMail className="icon" />

                  <input
                    type="email"
                    placeholder="Email Address"
                    value={
                      registerData.email
                    }
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        email:
                          e.target.value,
                      })
                    }
                    required
                  />
                </div> */}
                {/* PASSWORD */}
<div className="input-group">
  <FiLock className="icon" />

  <input
    className="password-input"
    type={showPassword ? "text" : "password"}
    placeholder="Password"
    value={registerData.password}
    onChange={(e) =>
      setRegisterData({
        ...registerData,
        password: e.target.value,
      })
    }
    minLength={8}
    maxLength={10}
    required
  />

  <span
    className="eye-icon"
    onClick={() =>
      setShowPassword(!showPassword)
    }
  >
    {showPassword ? (
      <FiEyeOff />
    ) : (
      <FiEye />
    )}
  </span>
</div>

                <button
                  type="submit"
                  className="auth-btn"
                   disabled={loading}

                >
                  {loading
                    ? "Submitting..."
                    : "Register"}
                </button>

                <p className="switch-text">
                  Already have an account?
                  <span
                    // onClick={() =>
                    //   setIsLogin(true)
                    // }
                    onClick={switchToLogin}
                  >
                    Login
                  </span>
                </p>
              </motion.form>
            )}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  );
};

export default AuthPage;